import { SlopResult, SlopApiError, Lead } from "./types";

const BASE = "https://us-central1-core6-ai-audit.cloudfunctions.net";

async function post<T>(path: string, body: object): Promise<T> {
  const res = await fetch(`${BASE}/${path}`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body),
  });
  let data: any = null;
  try {
    data = await res.json();
  } catch {
    /* non-JSON error body */
  }
  if (!res.ok) {
    if (data && data.error === true && data.code) {
      throw new SlopApiError(data.code, data.message);
    }
    throw new Error(data?.error || data?.message || `Request failed (${res.status})`);
  }
  return data as T;
}

export const api = {
  analyzeContent: (url: string) => post<SlopResult>("analyzeContent", { url }),
  getLeads: (password: string) => post<Lead[]>("slopGetLeads", { password }),
  deleteLead: (password: string, id: string) =>
    post<{ success: boolean }>("slopDeleteLead", { password, id }),
};